<template>
  <el-dialog
    title="健康宣教"
    :visible.sync="showHealthy"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :before-close="handleClose"
  >
    <div style="display:flex">
      <div class="dialog-main-content">
          <el-form>
            <el-row style="padding:0 15px">
              <el-col :span="16">
                <el-input
                  style="width: 100%; margin-bottom: 20px;margin-top:3px"
                  prefix-icon="el-icon-search"
                  placeholder="请输入宣教标题/主适配病种"
                  v-model="contentSearch"
                  clearable
                  size="small"
                ></el-input>
              </el-col>
              <!-- <el-col :span="8">
                  <el-form-item label="宣教类型：" label-width="90px">
                    <el-select v-model="missionType" clearable placeholder="内容状态" size="small">
                      <el-option v-for="item in missionTypeList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
              <el-col :span="8">
                <div class="search-btns">
                  <el-button size="small" @click="handleReset">重置</el-button>
                  <el-button
                    type="primary"
                    size="small"
                    @click.stop="searchRedundant"
                    >搜索</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </el-form>
          <div class="main-content-list">
            <el-table
              :data="healthyArr"
              :header-cell-style="{
                textAlign: 'center',
                color: '#333333',
                fontSize: '14px',
                fontWeight: 'bold',
                backgroundColor: '#FAFAFA'
              }"
              tooltip-effect="dark"
              border
              style="width: 700px"
            >
              <!-- <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column> -->
              <!-- <el-table-column
            prop="id"
            label="宣教ID"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column> -->
              <el-table-column
                prop="title"
                label="宣教标题"
                align="center"
                width="140"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="类型"
                align="center"
                width="234"
                show-overflow-tooltip
              >
                <template slot-scope="scope">{{
                  scope.row.missionType == 1
                    ? "推荐"
                    : scope.row.missionType == 2
                    ? "提醒"
                    : scope.row.missionType == 3
                    ? "辅导"
                    : ""
                }}</template>
              </el-table-column>
              <!-- <el-table-column label="归属" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{
              scope.row.attribution == 1
                ? "公域"
                : scope.row.attribution == 2
                ? "私域"
                : ""
            }}</template>
          </el-table-column> -->
              <el-table-column
                label="主适配病种"
                align="center"
                width="234"
                show-overflow-tooltip
              >
                <template slot-scope="scope">{{
                  scope.row.diseaseTypeName
                }}</template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="handleLookArticle(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    type="text"
                    size="medium"
                    @click="courseNameChange(scope.row)"
                    >选用</el-button
                  >
                </template>
              </el-table-column>
              <template
                slot="empty"
                v-if="
                  showCompanyBtn &&
                    $store.state.userPlatForm === 'platForm' &&
                    hospitalId &&
                    hospitalId !== 'null' &&
                    defaultIdType === 'hospitalId'
                "
              >
                <!-- 仅平台有 -->
                <div>
                  <div>对应机构暂无数据，是否去平台查找</div>
                  <el-button type="primary" size="small" @click="companySearch"
                    >搜平台</el-button
                  >
                </div>
              </template>
              <template
                slot="empty"
                v-if="defaultIdType === 'companyId' && !healthyArr.length"
              >
                <!-- 平台搜索过后也无数据的情况下展示 -->
                <div>
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current"
            :page-size="pageSize"
            layout="total,  prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
      </div>
      <div v-if="currentId" class="phone-container">
        <iframe
          :src="'/phone.html?id=' + currentId"
          width="100%"
          height="100%"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  // api_addSchemeItem,
  api_get_mission
  // api_Put_Scheme_Item,
} from "../api/toolapi";
export default {
  props: {
    showHealthy: {
      type: Boolean
    },
    notDisplayArticleArr: {
      type: Array,
      default: () => []
    },
    showCompanyBtn: {
      type: Boolean,
      default: false
    },
    hospitalId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      drawer: false,
      currentId: "",

      healthy: false,
      current: 1,
      pageSize: 10,
      contentSearch: "",
      missionType: "",
      total: 0,
      healthyArr: [],
      missionTypeList: [
        {
          label: "推荐",
          value: 1
        },
        {
          label: "提醒",
          value: 2
        },
        {
          label: "辅导",
          value: 3
        }
      ],
      defaultIdType: "hospitalId"
    };
  },
  created() {
    this.getMission();
  },
  methods: {
    // 重置
    handleReset() {
      this.contentSearch = "";
      this.current = 1;
      this.pageSize = 10;
      this.getMission();
    },
    handleClosePreview(done) {
      done();
      // this.drawer = false
    },
    handleClose() {
      this.$emit("update:showHealthy", false);
    },
    handleLookArticle(row) {
      this.drawer = true;
      this.currentId = row.id;
    },
    /**
     * @description:  获取宣教弹窗数据
     * @param {*}
     * @return {*}
     */
    getMission() {
      this.healthy = true;
      api_get_mission({
        current: this.current,
        size: this.pageSize,
        available: 1,
        title: this.contentSearch,
        deleted: 0,
        missionType: this.missionType,
        notDisplayList: this.notDisplayArticleArr,
        [this.defaultIdType]:
          this.defaultIdType === "hospitalId"
            ? this.hospitalId
            : this.$store.state.companyId
      }).then(res => {
        this.healthyArr = res.data.records;
        this.total = res.data.total;
      });
    },
    companySearch() {
      this.defaultIdType = "companyId";
      this.getMission();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMission();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getMission();
    },
    searchRedundant() {
      this.getMission();
    },
    /**
     * @description:  宣教问卷选择change事件
     * @param {*}
     * @return {*}
     */
    courseNameChange(row) {
      // this.form.courseName = row.title
      // this.form.refId = row.id
      this.$emit("receiveArticle", row);
      this.$emit("update:showHealthy", false);
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  p {
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    margin-right: 12px;
  }
  h1 {
    font-size: 14px;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
  }
}
.add-dialog {
  .title {
    font-size: 14px;
    color: #000;
    border-left: 4px solid #1a7bfc;
    padding-left: 10px;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .content {
    // height: calc(80vh - 140px);
    width: 100%;
    /deep/.el-input,
    .el-select {
      width: 100%;
    }
  }
}

/deep/.el-dialog__title {
  font-weight: 26px;
  color: #333;
  font-weight: bold;
}
/deep/.el-dialog__footer {
  text-align: center;
  .el-button {
    width: 110px;
    height: 32px;
    padding: 0;
    // line-height: 32px;
  }
}
.phone-container {
  width: 414px;
  height: 736px;
  border: 1px solid #999;
  margin: 0 auto;
}
// .list-question-wrap {
//   // height: 100%;
// }
/deep/.el-dialog {
  // max-width: 80%;
  // min-width: 50%;
  width: fit-content;
}
/deep/.el-dialog__body {
  padding-top: 0px;
}
/deep/.el-dialog__header {
  padding-left: 35px;
}
.search-btns {
  margin-top: 3px;
  text-align: right;
}
.el-main {
  width: 100%;
  .main-content-list {
    height: 62vh;
    overflow: auto;
    padding: 15px;
    padding-top: 8px;
    background-color: #fff;
  }
}
.el-pagination {
  text-align: right;
  margin-top: 15px;
  margin-right: 40px;
}
.btn-bg {
  background: #1a7bfc;
  color: #fff;
}
.dialog-main-content {
  display: flex;
  flex-direction: column;
}
/deep/.el-table td {
  padding: 6px 0;
}
h1 {
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  text-align: center;
}
</style>